<template>
	<div class="border-top">
		<SOFilterTitle :title="title" :diterapkan="diterapkan()" :id="id"/>
		<div class="p-l-24 p-r-24 p-d-24" v-show="false" :id="id">
			<SOInputCheckbox
				:checkboxes="checkbox"
				:checked="filterItem[this.filterName]"
				@selected="selected"
				:use-check-all="useCheckAll"
			/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"

import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";

export default {
	name: "SOFilterCheckbox",
	components: {
		SOFilterTitle,
		SOInputCheckbox,
	},
	props: {
		id: String,
        filterName: {
            type: String,
            required: true,
        },
        items: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: "Title",
        },
		useCheckAll: {
			type: Boolean,
			default: false,
		}
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem"
		}),
        checkbox() {
            return {
                name: 'checkboxFilter',
                data: this.items,
            }
        },
        filter() {
            return this.filterItem[this.filterName]
        },
	},
	mounted() {
		this.diterapkan()
		this.initState()
	},
	// watch: {
	// 	filter: {
	// 		handler: function () {
	// 			this.diterapkan = this.filterItem[this.filterName].length > 0
	// 		}
	// 	}
	// },
	data() {
		return {
			checked: [],
		}
	},
	methods: {
		async initState() {
			if (this.filterItem[this.filterName] == undefined || !Array.isArray(this.filterItem[this.filterName])) {
				let temp = this.filterItem
				temp = {
					...temp,
					[this.filterName]: [],
				}
				this.$store.commit("filterGlobalModule/setFilterItem", temp)
			}
		},
        diterapkan() {
			if (this.filterItem[this.filterName] ) {
				return this.filterItem[this.filterName].length > 0
			}
			return false
        },
		selected(val) {
			if (val == undefined) {
				val = []
			}
			this.initState()
			let temp = this.filterItem
			temp[this.filterName] = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
		}
	}
}
</script>